require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-mark-gilmore.json") })
        }
      }, "path---people-mark-gilmore");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-mark-gilmore!./.cache/json/people-mark-gilmore.json
// module id = 1465
// module chunks = 231608221292675